module.exports = __webpack_public_path__ + "static/media/occasion-anniversaries.d5a2effc.png";